import ReactGA from 'react-ga4';

export function trackEvent(eventName: string, properties?: Record<string, any>) {
  try {
    const isTester = localStorage.getItem('satu-wajan-tester') === 'true';
    const payload = {
      event: eventName,
      properties: {
        ...properties,
        isTester
      },
      timestamp: new Date().toISOString()
    };
    
    // For now, write to console. In the future this can hit a telemetry endpoint.
    console.log('[Analytics]', payload);

    // Auto-calculate and track 'Time-to-First-Recipe'
    if (eventName === 'menu_generated') {
      const isFirstRecipe = !localStorage.getItem('satu-wajan-first-recipe-generated-tracked');
      if (isFirstRecipe) {
        const sessionStart = sessionStorage.getItem('satu-wajan-session-start');
        if (sessionStart) {
          const elapsedSeconds = Math.round((Date.now() - parseInt(sessionStart, 10)) / 1000);
          localStorage.setItem('satu-wajan-first-recipe-generated-tracked', 'true');
          
          // Fire sub-event 'time_to_first_recipe' safely via a brief deferral
          setTimeout(() => {
            trackEvent('time_to_first_recipe', {
              duration_seconds: elapsedSeconds,
              target_met: elapsedSeconds < 90,
              generated_type: properties?.type || 'unknown'
            });
          }, 100);
        }
      }
    }

    // Send to Google Analytics 4 if initialized
    if (ReactGA.isInitialized) {
      ReactGA.event({
        category: 'Applet',
        action: eventName,
        label: properties ? JSON.stringify(properties) : undefined,
        value: properties?.value || properties?.cost || undefined,
        ...properties, // Merge properties as custom dimensions/metrics
        isTester
      } as any);
    }

  } catch (error) {
    // Ignore analytics errors silently
  }
}
